module.exports = __webpack_public_path__ + "img/sdg_icon_08.9b77d11c.png";